<template>
  <transition name="modal" >
        <div class="modal-mask" v-if="show" @click="$emit('close')" @mousemove="onMouseMove" @mouseenter="onMouseEnter">
          <div class="follower" ref="follower">
            <CloseButton :radius="16" :strokeWidth="2" />
          </div>
          <div class="mouse" ref="mouse"></div>
          <div class="modal-wrapper">
            <div class="modal-container" @mouseenter="onMouseOverContainer" @mouseleave="onMouseOutContainer" @click.stop>

              <div class="modal-header">
                <img :src="loadImg(eyecatch)" >
              </div>

              <div class="modal-body">
                  <h1>{{title}}</h1>
                  <div v-for="file in files" :key="file.filetype">
                    <DownloadButton :filetype="file.filetype" :filename="file.filename" />
                  </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
import DownloadButton from '../Atoms/DownloadButton'
import CloseButton from '../Atoms/CloseButton'
import gsap from 'gsap'

export default {
  name: 'Modal',
  props: {
    show: Boolean,
    title: {
      type: String,
      default: 'タイトル'
    },
    eyecatch: {
      type: String,
      default: 'card-thumbnail-full.svg'
    },
    files: {
      type: Array,
      default: function () {
        return [{filetype: 'SVG', filename: 'test'}]
      }
    }
  },
  data () {
    return {
      progress: 0,
      mouseX: 0,
      mouseY: 0,
      posX: 0,
      posY: 0,
      delay: 10,
      fWidth: 20,
      speed: 0.2
    }
  },
  methods: {
    loadImg: function (srcPath) {
      let image = require.context('@/assets/images', false, /\.png$|\.jpg$|\.svg$|\.tif$/)
      return image('./' + srcPath)
    },
    onMouseMove: function (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY
      this.$refs.mouse.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)'
    },
    onMouseEnter: function (e) {
      this.mouseX = e.clientX
      this.mouseY = e.clientY
      let $ref = this.$refs.follower
      $ref.style.opacity = 0.2
      gsap.ticker.add(() => {
        var dt = 1.0 - Math.pow(1.0 - this.speed, gsap.ticker.deltaRatio())
        this.posX += (this.mouseX - this.posX) * dt
        this.posY += (this.mouseY - this.posY) * dt
        gsap.set($ref, {
          x: this.posX,
          y: this.posY
        })
      })
    },
    onMouseOverContainer: function (e) {
      let $ref = this.$refs.follower
      $ref.style.opacity = 0
      this.$refs.mouse.style.opacity = 0
    },
    onMouseOutContainer: function (e) {
      let $ref = this.$refs.follower
      $ref.style.opacity = 0.2
      this.$refs.mouse.style.opacity = 1
    }
  },
  components: {
    DownloadButton,
    CloseButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  display: table;
  backdrop-filter: blur(20px);
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  max-width: 36rem;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 1.2rem;
  box-shadow: 0px 24px 56px rgba(0, 0, 0, 0.25);
  transition: all 0.45s ease;
  transition-delay: .15s;
  font-family: Helvetica, Arial, sans-serif;
  overflow: hidden;
}

.modal-header {
  position: relative;
}

.modal-header img{
  width: 100%;
  height: auto;
}

.modal-body {
  margin: 0 2.4rem 3.2rem;
}

.modal-body h1 {
  font-size: var(--large-font-size);
  line-height: 1.55555555556;
  font-weight: var(--bold-font-weight);
  margin: 2.4rem 0;
}

.download-button {
  margin-bottom: 1rem;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter.modal-mask, .modal-leave-to.modal-mask {
  top: 100vh;
}

.modal-enter-active.modal-mask, .modal-leave-active.modal-mask {
  transition: 0.3s ease-in-out;
}

.modal-enter-to.modal-mask, .modal-leave.modal-mask {
  top: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  opacity: 0;
}

.follower {
  position: fixed;
  top: -40px;
  left: 10px;
  opacity: 0;
  pointer-events:none;
  transition: opacity 0.5s;
}

</style>



// WEBPACK FOOTER //
// src/components/Organisms/Modal.vue